import { Link } from "react-router";
import type { TournamentSummary } from "../../lib/api";

export function PreparationHeader({
  eyebrow,
  title,
  description,
  season,
  tournamentId,
  tournaments,
}: {
  eyebrow: string;
  title: string;
  description: string;
  season: number;
  tournamentId: string;
  tournaments: TournamentSummary[];
  onSeasonChange: (season: number) => void;
  onTournamentChange: (id: string) => void;
}) {
  const selected = tournaments.find((item) => item.id === tournamentId);
  return (
    <article className="panel prep-context">
      <div>
        <span className="eyebrow">{eyebrow}</span>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      <div className="prep-context-controls prep-context-locked">
        <div className="prep-context-lock-copy">
          <span>AKTYWNY TURNIEJ</span>
          <strong>{selected?.name || title}</strong>
          <small>Sezon {season} · ten kontekst jest zablokowany</small>
        </div>
        <Link className="secondary-button" to={`/tournaments?season=${season}`}>← Lista turniejów</Link>
      </div>
    </article>
  );
}
